import {Routes} from '@angular/router';
import {WorkPageComponent} from './work-page.component';
import {WorkHistoryScreenComponent} from './steps/history/work-history-screen.component';
import {WorkHistoryScreensManager} from './steps/history/work-history-screens-manager.service';
import {MilitaryExperienceScreenComponent} from './steps/military/military-experience-screen.component';
import {WorkObservationsScreenComponent} from './steps/observations/work-observations-screen.component';
import {WorkObservationsScreensManager} from './steps/observations/work-observations-screens-manager.service';
import {ActivityLogsScreenComponent} from './steps/activity-logs/activity-logs-screen.component';
import {WorkHistoryNotesScreenComponent} from './steps/work-history-notes/work-history-notes-screen.component';
import {AuthInfo} from '../../components/security/authorization/auth.guard';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'work',
    component: WorkPageComponent,
    children: [
        {path: '', redirectTo: 'history/1', pathMatch: 'full'},
        {path: 'history', redirectTo: 'history/1', pathMatch: 'full'},
        {
            path: 'history/:index',
            component: WorkHistoryScreenComponent,
            data: {step: {screensManager: WorkHistoryScreensManager}}
        },
        {path: 'activityLogs', component: ActivityLogsScreenComponent},
        {path: 'military', component: MilitaryExperienceScreenComponent},
        {
            path: 'observations',
            component: WorkObservationsScreenComponent,
            data: {step: {screensManager: WorkObservationsScreensManager}}
        },
        {path: 'workHistoryNotes', component: WorkHistoryNotesScreenComponent, data: {auth: new AuthInfo({roles: ['ADMIN']})}}
    ],
    data: {section: {title: 'Work History'}, impersonationAllowed: true}
}];
export default routes;

export const screenManagers = [WorkHistoryScreensManager, WorkObservationsScreensManager];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/work-page.routing.ts